'use strict';

function savePayload(integrationTemplateId, credentials) {
    var payload = { integrationTemplateId: integrationTemplateId };
    Object.keys(credentials || {}).forEach(function (key) {
        payload[key] = credentials[key];
    });
    return payload;
}

function connectTypedCredentials(options) {
    var integrationTemplate = options.integrationTemplate;
    var credentials = options.credentials || {};
    var testUrl = options.slsBaseUrl + '/integrations/' + integrationTemplate.provider + '/test';
    var saveUrl = options.apiBaseUrl + '/integrations/saveTypedCredentials';

    return options.$http.post(testUrl, credentials)
        .then(function () {
            return options.$http.post(saveUrl, savePayload(integrationTemplate.id, credentials))
                .catch(function (error) {
                    if (error && typeof error === 'object') {
                        error.typedCredentialsFailureStage = 'save';
                    }
                    throw error;
                });
        })
        .then(function (response) {
            return response.data;
        });
}

function connectionErrorMessage(error) {
    var code = error && error.data && error.data.error && error.data.error.code;
    var apiMessage = error && error.data && error.data.error && error.data.error.message;
    var messages = {
        ACHIEVERS_AUTH_FAILED: 'Achievers could not authenticate these credentials. ' +
            'Check the client ID and client secret, then try again.',
        ACHIEVERS_RATE_LIMITED: 'Achievers is temporarily limiting connection tests. ' +
            'Wait a moment and try again.',
        ACHIEVERS_URL_INVALID: 'Achievers could not use that program URL. ' +
            'Enter an HTTPS achievers.com URL ending in /api/v5, then try again.',
        MISSING_CREDENTIAL_FIELDS: 'Enter all required integration credentials, then try again.',
        WORKDAY_CONNECTION_FAILED: 'Could not connect to Workday. ' +
            'Check the Workday host, tenant, username, and password, then try again.',
    };

    if (error && error.typedCredentialsFailureStage === 'save') {
        if (apiMessage && !/1password/i.test(apiMessage)) return apiMessage;
        return 'Could not save the integration credentials. Check your access and try again.';
    }

    return messages[code] ||
        'Could not verify the integration connection. Check the required credentials and try again.';
}

if (typeof module !== 'undefined' && typeof exports !== 'undefined' && module.exports === exports) {
    module.exports = {
        connectionErrorMessage: connectionErrorMessage,
        connectTypedCredentials: connectTypedCredentials,
    };
}

if (typeof angular !== 'undefined') {
    angular.module('rocket.components').value('typedCredentialsConnection', {
        connect: connectTypedCredentials,
        errorMessage: connectionErrorMessage,
    });
}
